<template>
  <div class="common-tab-box merge-city-job hot-job-box">
    <div class="box-title">职位推荐</div>
    <el-card class="box-card" shadow="hover" v-for="(vItem, vIndex) in jobList.slice(0, 9)" :key="vIndex" :body-style="{ width: (minWidth - 16 * 4) / 3 + 'px', padding: '0px' }">
      <div class="sub-li" @click="jobDetail(vItem)">
        <div class="job-info">
          <div class="sub-li-top flexElm">
            <span v-if="vItem.recommend === '1'" class="hot_span">热招</span>
            <p class="name hideText">{{ vItem.jobs_name }}</p>
            <p class="salary hideText">{{ vItem.wage_cn }}</p>
          </div>
          <p class="job-text">
            <span>{{ vItem.nature_cn || '无' }}</span>
            <span>{{ vItem.district_cn }}</span>
            <span>{{ vItem.education_cn }}</span>
          </p>
        </div>
        <div class="sub-li-bottom">
          <div class="flexElm user-info">
            <p class="flex">
              <img :src="vItem.logo" />
              <span class="name">{{ vItem.companyname }}</span>
            </p>
            <p class="sub-li-bottom-commany-info">
              <!-- <span class="type">{{vItem.district_cn}}</span> -->
              <!-- <span class="vline"></span> -->
              <span class="level">{{ vItem.ntime }}</span>
            </p>
          </div>
        </div>
      </div>
    </el-card>
    <el-tabs v-if="false" v-model="activeName" :stretch="true">
      <el-tab-pane :label="item.name" :name="index + '1'" v-for="(item, index) in jobList" :key="index">
        <el-card class="box-card" shadow="hover" v-for="(vItem, vIndex) in item.children.slice(0, 9)" :key="vIndex" :body-style="{ width: (minWidth - 16 * 4) / 3 + 'px', padding: '0px' }">
          <div class="sub-li" @click="jobDetail(vItem)">
            <div class="job-info">
              <div class="sub-li-top flexElm">
                <p class="name hideText">{{ vItem.jobs_name }}</p>
                <p class="salary hideText">{{ vItem.wage_cn }}</p>
              </div>
              <p class="job-text">
                <span>{{ vItem.nature_cn || '无' }}</span>
                <span>{{ vItem.district_cn }}</span>
                <span>{{ vItem.education_cn }}</span>
              </p>
            </div>
            <div class="sub-li-bottom">
              <div class="flexElm user-info">
                <p class="flex">
                  <img :src="vItem.logo" />
                  <span class="name">{{ vItem.companyname }}</span>
                </p>
                <p class="sub-li-bottom-commany-info">
                  <!-- <span class="type">{{vItem.district_cn}}</span> -->
                  <!-- <span class="vline"></span> -->
                  <span class="level">{{ vItem.ntime }}</span>
                </p>
              </div>
            </div>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <p class="common-tab-more"><span class="btn btn-outline" @click="seeMore">查看更多</span></p>
  </div>
</template>

<script>
export default {
  name: 'HotJob',
  props: {
    minWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeName: '01',
      jobList: []
    };
  },
  methods: {
    setData(data) {
      if (data) {
        data.forEach((item) => {
          this.$set(item, 'logo', window.global.avatarUrl + 'avatars.php?&type=1&uid=' + item.uid);
        });
      }
      this.jobList = data || [];
    },
    //职位明细
    jobDetail(item) {
      this.$router.push({
        path: '/person/position/jobDetail',
        query: {
          id: item.id
        }
      });
      // let routeUrl = this.$router.resolve({
      // 	path: '/person/position/jobDetail',
      // 	query: {
      // 		id: item.id
      // 	}
      // })
      // window.open(routeUrl.href, '_blank')
    },
    //查看更多职位
    seeMore() {
      this.$router.push('/person/positionIndex');
    }
  }
};
</script>

<style scoped>
.user-info .name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* max-width: 168px; */
}

.user-info p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.user-info {
  width: 100%;
}
.hot_span {
  border: 1px solid #007aff;
  color: #007aff !important;
  white-space: nowrap;
  font-size: 12px;
  line-height: 12px;
  padding: 2px 2px;
  margin-right: 4px;
  border-radius: 3px;
  float: left;
}
.user-info p:nth-child(1) {
  width: 90%;
  margin-right: 20px;
}

.user-info p:nth-child(2) {
  width: 35%;
  text-align: right;
  color: #fe574a;
}
</style>
